export default {
  categories: {
    items: {
      text: {
        'ui:widget': 'EditorMarkdownWidget',
      },
      color: {
        'ui:widget': 'BaseColorWidget',
      },
      additionalInfo: {
        'ui:widget': 'EditorMarkdownWidget',
      },
      tickets: {
        items: {
          value: {
            'ui:widget': 'EditorTicketWidget',
          },
        },
      },
    },
  },
}
